/**
 * TPC Variant Modal
 * Shared quick-add modal for multi-variant products.
 * Usage: window.TPCVariantModal.open(productData)
 */
window.TPCVariantModal = (function () {
  var overlayEl = null;
  var modalEl = null;
  var currentProduct = null;
  var selectedOptions = {};
  var selectedVariant = null;
  var triggerElement = null;
  var moneyFormat = '${{amount}}';

  /* ============================================================
     Public API
     ============================================================ */
  return { open: open };

  /* ============================================================
     open(productData, triggerEl)
     ============================================================ */
  function open(productData, triggerEl) {
    currentProduct = productData;
    triggerElement = triggerEl || document.activeElement;
    moneyFormat = productData.money_format || '${{amount}}';

    /* Set initial selections from first available variant */
    selectedOptions = {};
    var firstAvailable = null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (productData.variants[i].available) {
        firstAvailable = productData.variants[i];
        break;
      }
    }
    if (!firstAvailable) firstAvailable = productData.variants[0];

    if (firstAvailable.option1 != null) selectedOptions['option1'] = firstAvailable.option1;
    if (firstAvailable.option2 != null) selectedOptions['option2'] = firstAvailable.option2;
    if (firstAvailable.option3 != null) selectedOptions['option3'] = firstAvailable.option3;

    selectedVariant = firstAvailable;

    buildModal();
    renderContent();
    showModal();
  }

  /* ============================================================
     DOM Creation (once)
     ============================================================ */
  function buildModal() {
    if (overlayEl) return;

    overlayEl = document.createElement('div');
    overlayEl.className = 'tpc-vm-overlay';
    overlayEl.setAttribute('role', 'dialog');
    overlayEl.setAttribute('aria-modal', 'true');
    overlayEl.setAttribute('aria-label', 'Select product options');

    overlayEl.innerHTML =
      '<div class="tpc-vm">' +
        '<button class="tpc-vm__close" aria-label="Close" type="button">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' +
            '<line x1="18" y1="6" x2="6" y2="18"/>' +
            '<line x1="6" y1="6" x2="18" y2="18"/>' +
          '</svg>' +
        '</button>' +
        '<div class="tpc-vm__body">' +
          '<div class="tpc-vm__image-col">' +
            '<img class="tpc-vm__image" src="" alt="" />' +
          '</div>' +
          '<div class="tpc-vm__info-col">' +
            '<h3 class="tpc-vm__title"></h3>' +
            '<div class="tpc-vm__price-wrap">' +
              '<span class="tpc-vm__price"></span>' +
              '<span class="tpc-vm__compare-price"></span>' +
            '</div>' +
            '<div class="tpc-vm__options"></div>' +
            '<p class="tpc-vm__availability" style="display:none"></p>' +
            '<button class="tpc-vm__add-btn" type="button">Add to Cart</button>' +
            '<a class="tpc-vm__view-link" href="">View Full Details</a>' +
          '</div>' +
        '</div>' +
      '</div>';

    modalEl = overlayEl.querySelector('.tpc-vm');
    document.body.appendChild(overlayEl);

    /* Event listeners */
    overlayEl.querySelector('.tpc-vm__close').addEventListener('click', closeModal);
    overlayEl.addEventListener('click', function (e) {
      if (e.target === overlayEl) closeModal();
    });
    document.addEventListener('keydown', handleKeyDown);
    overlayEl.querySelector('.tpc-vm__add-btn').addEventListener('click', handleAddToCart);
  }

  /* ============================================================
     Render Content
     ============================================================ */
  function renderContent() {
    var p = currentProduct;

    /* Title */
    overlayEl.querySelector('.tpc-vm__title').textContent = p.title;

    /* Image */
    var imgSrc = getVariantImage() || (p.featured_image ? p.featured_image.src : '');
    var imgEl = overlayEl.querySelector('.tpc-vm__image');
    imgEl.src = imgSrc;
    imgEl.alt = p.title;

    /* Price */
    updatePriceDisplay();

    /* View link */
    overlayEl.querySelector('.tpc-vm__view-link').href = p.url || '#';

    /* Options */
    renderOptions();

    /* Availability */
    updateAvailability();
  }

  /* ============================================================
     Render Option Groups
     ============================================================ */
  function renderOptions() {
    var optionsContainer = overlayEl.querySelector('.tpc-vm__options');
    optionsContainer.innerHTML = '';

    var p = currentProduct;
    if (!p.options || p.options.length === 0) return;

    for (var i = 0; i < p.options.length; i++) {
      var option = p.options[i];
      var optionKey = 'option' + (i + 1);
      var values = getOptionValues(option);

      var group = document.createElement('div');
      group.className = 'tpc-vm__option-group';

      var label = document.createElement('span');
      label.className = 'tpc-vm__option-label';
      label.textContent = option.name;
      group.appendChild(label);

      var valuesWrap = document.createElement('div');
      valuesWrap.className = 'tpc-vm__option-values';

      for (var j = 0; j < values.length; j++) {
        var val = values[j];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tpc-vm__option-btn';
        btn.textContent = val;
        btn.setAttribute('data-option-key', optionKey);
        btn.setAttribute('data-option-value', val);
        btn.setAttribute('aria-pressed', selectedOptions[optionKey] === val ? 'true' : 'false');

        if (selectedOptions[optionKey] === val) {
          btn.classList.add('tpc-vm__option-btn--selected');
        }

        btn.addEventListener('click', handleOptionClick);
        valuesWrap.appendChild(btn);
      }

      group.appendChild(valuesWrap);
      optionsContainer.appendChild(group);
    }

    updateOptionAvailability();
  }

  function getOptionValues(option) {
    /* option.values can be an array of strings or objects with .name */
    var values = [];
    if (!option.values) return values;
    for (var i = 0; i < option.values.length; i++) {
      var v = option.values[i];
      values.push(typeof v === 'string' ? v : (v.name || v.title || String(v)));
    }
    return values;
  }

  /* ============================================================
     Option Click Handler
     ============================================================ */
  function handleOptionClick(e) {
    var btn = e.currentTarget;
    var optionKey = btn.getAttribute('data-option-key');
    var optionValue = btn.getAttribute('data-option-value');

    selectedOptions[optionKey] = optionValue;
    resolveVariant();

    /* Update selected states */
    var siblings = btn.parentElement.querySelectorAll('.tpc-vm__option-btn');
    for (var i = 0; i < siblings.length; i++) {
      var isSelected = siblings[i].getAttribute('data-option-value') === optionValue;
      siblings[i].classList.toggle('tpc-vm__option-btn--selected', isSelected);
      siblings[i].setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }

    updateOptionAvailability();
    updatePriceDisplay();
    updateImage();
    updateAvailability();
  }

  /* ============================================================
     Resolve Variant
     ============================================================ */
  function resolveVariant() {
    var variants = currentProduct.variants;
    selectedVariant = null;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;

      if (selectedOptions.option1 != null && v.option1 !== selectedOptions.option1) match = false;
      if (selectedOptions.option2 != null && v.option2 !== selectedOptions.option2) match = false;
      if (selectedOptions.option3 != null && v.option3 !== selectedOptions.option3) match = false;

      if (match) {
        selectedVariant = v;
        break;
      }
    }
  }

  /* ============================================================
     Update Option Availability (cascading)
     ============================================================ */
  function updateOptionAvailability() {
    var allBtns = overlayEl.querySelectorAll('.tpc-vm__option-btn');

    for (var i = 0; i < allBtns.length; i++) {
      var btn = allBtns[i];
      var optionKey = btn.getAttribute('data-option-key');
      var optionValue = btn.getAttribute('data-option-value');

      /* Check if any variant with this value (and other current selections) is available */
      var isAvailable = false;
      var variants = currentProduct.variants;

      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        if (v[optionKey] !== optionValue) continue;

        /* Check other selected options match */
        var otherMatch = true;
        for (var key in selectedOptions) {
          if (key === optionKey) continue;
          if (selectedOptions[key] != null && v[key] !== selectedOptions[key]) {
            otherMatch = false;
            break;
          }
        }

        if (otherMatch && v.available) {
          isAvailable = true;
          break;
        }
      }

      btn.classList.toggle('tpc-vm__option-btn--unavailable', !isAvailable);
    }
  }

  /* ============================================================
     Update Price Display
     ============================================================ */
  function updatePriceDisplay() {
    var priceEl = overlayEl.querySelector('.tpc-vm__price');
    var compareEl = overlayEl.querySelector('.tpc-vm__compare-price');

    if (selectedVariant) {
      priceEl.textContent = formatMoney(selectedVariant.price);
      if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
        compareEl.textContent = formatMoney(selectedVariant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  /* ============================================================
     Update Image
     ============================================================ */
  function updateImage() {
    var imgEl = overlayEl.querySelector('.tpc-vm__image');
    var newSrc = getVariantImage() || (currentProduct.featured_image ? currentProduct.featured_image.src : '');
    if (imgEl.src !== newSrc && newSrc) {
      imgEl.style.opacity = '0';
      imgEl.onload = function () { imgEl.style.opacity = '1'; };
      imgEl.src = newSrc;
    }
  }

  function getVariantImage() {
    if (selectedVariant && selectedVariant.featured_image && selectedVariant.featured_image.src) {
      return selectedVariant.featured_image.src;
    }
    return null;
  }

  /* ============================================================
     Update Availability Status
     ============================================================ */
  function updateAvailability() {
    var addBtn = overlayEl.querySelector('.tpc-vm__add-btn');
    var availEl = overlayEl.querySelector('.tpc-vm__availability');

    addBtn.classList.remove('tpc-vm__add-btn--disabled', 'tpc-vm__add-btn--added', 'tpc-vm__add-btn--adding');

    if (!selectedVariant) {
      addBtn.textContent = 'Unavailable';
      addBtn.classList.add('tpc-vm__add-btn--disabled');
      availEl.style.display = 'none';
    } else if (!selectedVariant.available) {
      addBtn.textContent = 'Sold Out';
      addBtn.classList.add('tpc-vm__add-btn--disabled');
      availEl.textContent = 'This combination is currently sold out';
      availEl.style.display = '';
    } else {
      addBtn.textContent = 'Add to Cart';
      availEl.style.display = 'none';
    }
  }

  /* ============================================================
     Add to Cart
     ============================================================ */
  function handleAddToCart() {
    if (!selectedVariant || !selectedVariant.available) return;

    var addBtn = overlayEl.querySelector('.tpc-vm__add-btn');
    addBtn.classList.add('tpc-vm__add-btn--adding');
    addBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        addBtn.classList.remove('tpc-vm__add-btn--adding');
        addBtn.classList.add('tpc-vm__add-btn--added');
        addBtn.textContent = 'Added \u2713';

        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              itemCount: cart.item_count,
              source: 'tpc-variant-modal'
            }
          }
        }));

        setTimeout(function () {
          closeModal();
        }, 800);
      })
      .catch(function () {
        addBtn.classList.remove('tpc-vm__add-btn--adding');
        addBtn.textContent = 'Add to Cart';
      });
  }

  /* ============================================================
     Show / Close Modal
     ============================================================ */
  function showModal() {
    document.body.classList.add('tpc-vm-body-locked');
    /* Force reflow before adding open class for animation */
    void overlayEl.offsetWidth;
    overlayEl.classList.add('tpc-vm-overlay--open');

    /* Focus close button */
    setTimeout(function () {
      overlayEl.querySelector('.tpc-vm__close').focus();
    }, 50);
  }

  function closeModal() {
    overlayEl.classList.remove('tpc-vm-overlay--open');
    document.body.classList.remove('tpc-vm-body-locked');

    /* Reset add button state */
    var addBtn = overlayEl.querySelector('.tpc-vm__add-btn');
    addBtn.classList.remove('tpc-vm__add-btn--adding', 'tpc-vm__add-btn--added', 'tpc-vm__add-btn--disabled');
    addBtn.textContent = 'Add to Cart';

    /* Return focus */
    if (triggerElement && triggerElement.focus) {
      triggerElement.focus();
    }
  }

  /* ============================================================
     Keyboard Handler
     ============================================================ */
  function handleKeyDown(e) {
    if (!overlayEl || !overlayEl.classList.contains('tpc-vm-overlay--open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }

    /* Focus trap */
    if (e.key === 'Tab') {
      var focusable = overlayEl.querySelectorAll(
        'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  /* ============================================================
     Money Formatting
     ============================================================ */
  function formatMoney(cents) {
    if (cents == null) return '';
    var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amount.split('.')[0].replace(/,/g, '.'));
  }
})();
